import { render } from "./ExperienceDetail.vue?vue&type=template&id=07aa459b&scoped=true"
import script from "./ExperienceDetail.vue?vue&type=script&lang=js"
export * from "./ExperienceDetail.vue?vue&type=script&lang=js"

import "./ExperienceDetail.vue?vue&type=style&index=0&id=07aa459b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1372789139/src/portfolio-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07aa459b"]])

export default __exports__